module.exports = __webpack_public_path__ + "assets/4b01a4128545c7a7cac37f576e1cb651.json";